import { render } from "./gang-change-connection-type.vue?vue&type=template&id=4c8d5ec6"
import script from "./gang-change-connection-type.vue?vue&type=script&lang=js"
export * from "./gang-change-connection-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__